<div *ngIf="showDevComments" class="dev-comment text-center">
  src\app\landowner-admin-shared\components\season-lookup-grid\season-lookup-grid.component.html
</div>

<div class="flx-container">
  <div *ngIf="title" class="flx-item title">{{ title }}</div>
  <div *ngIf="title" class="flx-break"></div>

  <div class="flx-item">
    <span class="link search-tool" (click)="onSelectAllClick()"> Select All </span>
    <span class="link search-tool" (click)="onSelectNoneClick()"> Select None </span>

    <div class="search-tool">
      <input
        type="text"
        id="season-lookup-grid-keyword-input"
        class="form-control"
        [(ngModel)]="keyword"
        (ngModelChange)="onKeywordChange($event)"
        placeholder="Filter By Keyword"
      />
    </div>

    <span class="search-tool">
      <div class="checkbox">
        <label>
          <input type="checkbox" [(ngModel)]="onlyShowGlobal" (ngModelChange)="onShowGlobalChange($event)" />
          Global Only
        </label>
      </div>
    </span>
  </div>

  <div class="flx-break"></div>

  <div *ngIf="tagNames && tagNames.length > 0" class="flx-item">
    <button *ngFor="let tagName of tagNames" class="btn btn-info btn-round" (click)="onTagButtonClick(tagName)">
      {{ tagName }}
    </button>
  </div>

  <div class="flx-break"></div>
  <div *ngIf="!retrieving" class="flx-item flx-fill">
    <div class="error-text" *ngIf="filteredRows && filteredRows.length === 0">No season lookups found.</div>

    <div class="tableWrap" >
      <table *ngIf="showTable" class="adminTable">
        <thead>
          <tr>
            <th></th>
            <th (click)="setSortCol('id')" style="cursor: pointer" class="sortable-header">
              ID
              <sort-indicator [columnName]="'id'" [value]="sortCol" [sortDescending]="sortDescending"></sort-indicator>
            </th>
            <th (click)="setSortCol('name')" style="cursor: pointer" class="sortable-header">
              Name

              <sort-indicator [columnName]="'name'" [value]="sortCol" [sortDescending]="sortDescending"></sort-indicator>
            </th>

            <th>
              Start Date
              <sort-indicator [columnName]="'startDateTime'" [value]="sortCol" [sortDescending]="sortDescending"></sort-indicator>
            </th>

            <th>
              End Date
              <sort-indicator [columnName]="'endDateTime'" [value]="sortCol" [sortDescending]="sortDescending"></sort-indicator>
            </th>

            <th (click)="setSortCol('state')" style="cursor: pointer" class="sortable-header">
              State
              <sort-indicator [columnName]="'state'" [value]="sortCol" [sortDescending]="sortDescending"></sort-indicator>
            </th>

            <th (click)="setSortCol('isGlobal')" style="cursor: pointer" class="sortable-header">
              Global ?
              <sort-indicator [columnName]="'isGlobal'" [value]="sortCol" [sortDescending]="sortDescending"></sort-indicator>
            </th>

            <th *ngIf="tagsEnabled">Tags</th>

            <th></th>
          </tr>
        </thead>

        <tbody *ngIf="filteredRows">
          <tr *ngFor="let r of filteredRows">
            <td>
              <div class="checkbox">
                <label>
                  <input type="checkbox" [(ngModel)]="r.selected" />
                </label>
              </div>
            </td>
            <td>{{ r.id }}</td>
            <td>{{ r.name }} <oapopover *ngIf="r.description" [title]="r.name" [content]="r.description"></oapopover></td>

            <td>{{ r.startDateTime | date: "shortDate" }}</td>
            <td>{{ r.endDateTime | date: "shortDate" }}</td>

            <td>{{ r.state }}</td>

            <td>{{ r.isGlobal | yesNo }}</td>

            <td *ngIf="tagsEnabled">
              <span *ngFor="let tag of r.tags">
                <tag [deleteEnabled]="false" [tag]="tag"> </tag>
              </span>
            </td>

            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="retrieving" class="flx-item">
    <div class="flx-break"></div>
    <spinner *ngIf="retrieving" messageRelativePosition="bottom"> </spinner>
  </div>
</div>
